var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Sidebar from 'components/shared/sidebar/component';
import { SIDEBAR_MODE_ADMIN } from 'components/constants';
import { setT } from 'helpers/translationUtilities';
import { generatePathWithParams } from 'components/routers/router';
import { ADMIN_PATHS } from 'components/routers/constants';
import TinyMCE from 'components/shared/TinyMCE/component';
import { adminCreateTaskAction, adminGetTaskAction, adminUpdateTaskAction } from '../../../../../../../redux/actions/admin/admin.task.actions';
var populateTaskStateFields = function (task) { return ({
    name: task.reference.name[0].value,
    description: task.reference.description[0].content[0].value,
    skippable: task.skippable,
    reusable: task.reusable,
    stages: task.stages,
    companyIds: task.address.companyIds,
    target: task.address.target,
    order: task.order
}); };
export default function ViewSingleTemplateTaskEdit() {
    var _this = this;
    var _a, _b, _c;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _d = useParams(), id = _d.id, taskId = _d.taskId;
    var template = useSelector(function (state) { return state.admin.singleTemplate; });
    var stages = (_a = template === null || template === void 0 ? void 0 : template.stages) !== null && _a !== void 0 ? _a : [];
    var companies = (_b = template === null || template === void 0 ? void 0 : template.companies) !== null && _b !== void 0 ? _b : [];
    var _e = useState({
        name: '', description: '', skippable: false, reusable: false,
        stages: [], companyIds: [], target: 'Player', order: null
    }), fields = _e[0], setFields = _e[1];
    var _f = useState(true), hideCompanies = _f[0], setHideCompanies = _f[1];
    var _g = useState(true), hideStages = _g[0], setHideStages = _g[1];
    var _h = useState(false), showOrder = _h[0], setShowOrder = _h[1];
    useEffect(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var task, _a, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 4, , 5]);
                            if (!(taskId !== 'new')) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch(adminGetTaskAction(id, taskId))];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _a = null;
                            _b.label = 3;
                        case 3:
                            task = _a;
                            if (task) {
                                setFields(populateTaskStateFields(task));
                                setHideCompanies(task.address.companyIds.length === 0);
                                setHideStages(task.stages.length === 0);
                                setShowOrder(task.order !== null);
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            e_1 = _b.sent();
                            console.error(e_1);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        fetchData();
    }, [id, taskId]);
    var onTaskFormSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!(taskId === 'new')) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(adminCreateTaskAction(id, fields))];
                case 2:
                    data = _a.sent();
                    if ((data === null || data === void 0 ? void 0 : data._id) && data._id !== 'new') {
                        navigate(generatePathWithParams(ADMIN_PATHS.TEMPLATE_TASK, { id: id, taskId: data._id }));
                    }
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, dispatch(adminUpdateTaskAction(id, taskId, fields))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onFieldChange = function (name, value) { return setFields(function (prev) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
    }); };
    var onSelectFieldChange = function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        setFields(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = __spreadArray(__spreadArray([], prev[name], true), [value], false), _a)));
        });
        event.target.selectedIndex = 0;
    };
    var onClickRemoveFieldItem = function (name, value) {
        return setFields(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = prev[name].filter(function (item) { return item !== value; }), _a)));
        });
    };
    var onHideCompaniesChange = function (checked) {
        setHideCompanies(checked);
        if (checked)
            setFields(function (prev) { return (__assign(__assign({}, prev), { companyIds: [] })); });
    };
    var onHideStagesChange = function (checked) {
        setHideStages(checked);
        if (checked)
            setFields(function (prev) { return (__assign(__assign({}, prev), { stages: [] })); });
    };
    var onHideOrderChange = function (checked) {
        setShowOrder(checked);
        if (!checked)
            setFields(function (prev) { return (__assign(__assign({}, prev), { order: null })); });
    };
    var FormFieldStyles = { display: 'flex', flexDirection: 'row', gap: '2em', justifyContent: 'left', alignItems: 'flex-start' };
    var FormFieldLabelStyles = { maxWidth: '15em', width: '100%', textAlign: 'right' };
    return (React.createElement("div", null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_ADMIN }),
        React.createElement("div", { style: { margin: '5em 0 5em 5em' } },
            React.createElement("div", { style: { maxWidth: '75em', margin: 'auto', padding: '0 1em' } },
                React.createElement("form", { onSubmit: onTaskFormSubmit },
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1em' } },
                        React.createElement("label", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Task Name:"),
                            React.createElement("input", { name: "name", type: "text", value: fields.name, onChange: function (e) { return onFieldChange(e.target.name, e.target.value); } })),
                        React.createElement("label", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Task type:"),
                            React.createElement("select", { name: "target", onChange: function (e) { return onFieldChange(e.target.name, e.target.value); }, value: fields.target }, ['Player', 'Company'].map(function (item, i) { return React.createElement("option", { key: i, value: item }, item); }))),
                        React.createElement("label", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Player can skip this task:"),
                            React.createElement("input", { type: "checkbox", name: "skippable", checked: fields.skippable, onChange: function (e) { return onFieldChange(e.target.name, e.target.checked); } })),
                        React.createElement("div", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Task is available on all stages:"),
                            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1em', alignItems: 'flex-start' } },
                                React.createElement("input", { type: "checkbox", checked: hideStages, onChange: function (e) { return onHideStagesChange(e.target.checked); } }),
                                !hideStages && (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1em' } },
                                    React.createElement("select", { name: "stages", onChange: onSelectFieldChange },
                                        React.createElement("option", null, "- Select stages -"),
                                        stages.filter(function (s) { return !fields.stages.includes(s._id); }).map(function (s, i) { return React.createElement("option", { key: i, value: s._id }, s.title[0].value); })),
                                    React.createElement("div", null, stages.filter(function (s) { return fields.stages.includes(s._id); }).map(function (s, i) { return (React.createElement("div", { key: i, style: { position: 'relative', display: 'inline-block', margin: '.5em', padding: '.25em 2em .25em .5em', border: '1px solid black', borderRadius: '.5em' } },
                                        React.createElement("span", null, s.title[0].value),
                                        React.createElement("span", { className: "icon icon--close style--red", style: { position: 'absolute', top: '50%', right: '.5em', transform: 'translateY(-50%)' }, onClick: function () { return onClickRemoveFieldItem('stages', s._id); } }))); })))))),
                        React.createElement("div", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Task appears at specific order:"),
                            React.createElement("input", { type: "checkbox", checked: showOrder, onChange: function (e) { return onHideOrderChange(e.target.checked); } })),
                        showOrder && (React.createElement("div", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Enter order number:"),
                            React.createElement("input", { type: "number", name: "order", value: (_c = fields.order) !== null && _c !== void 0 ? _c : '', onChange: function (e) { return onFieldChange(e.target.name, Number(e.target.value)); } }))),
                        React.createElement("div", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Task appears to all players:"),
                            React.createElement("input", { type: "checkbox", checked: hideCompanies, onChange: function (e) { return onHideCompaniesChange(e.target.checked); } })),
                        !hideCompanies && (React.createElement("div", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Companies:"),
                            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1em' } },
                                React.createElement("select", { name: "companyIds", onChange: onSelectFieldChange },
                                    React.createElement("option", null, "- Select company -"),
                                    companies.filter(function (c) { return !fields.companyIds.includes(c._id); }).map(function (c, i) { return React.createElement("option", { key: i, value: c._id }, c.name[0].value); })),
                                React.createElement("div", null, companies.filter(function (c) { return fields.companyIds.includes(c._id); }).map(function (c, i) { return (React.createElement("div", { key: i, style: { position: 'relative', display: 'inline-block', margin: '.5em', padding: '.25em 2em .25em .5em', border: '1px solid black', borderRadius: '.5em' } },
                                    React.createElement("span", null, c.name[0].value),
                                    React.createElement("span", { className: "icon icon--close style--red", style: { position: 'absolute', top: '50%', right: '.5em', transform: 'translateY(-50%)' }, onClick: function () { return onClickRemoveFieldItem('companyIds', c._id); } }))); }))))),
                        React.createElement("div", { style: FormFieldStyles },
                            React.createElement("span", { style: FormFieldLabelStyles }, "Task Description:"),
                            React.createElement(TinyMCE, { value: fields.description || null, onChange: function (value) { return onFieldChange('description', value); } })),
                        React.createElement("div", { style: FormFieldStyles },
                            React.createElement("div", { style: FormFieldLabelStyles },
                                React.createElement(Link, { to: "/admin/templates/".concat(id) }, setT('Back'))),
                            React.createElement("button", null, taskId === 'new' ? 'create' : 'Update'))))))));
}
